import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import styles from './Cell.module.scss';

const Cell = ({
  children,
  className,
  minWidth,
  maxWidth,
  justifyContent,
  ...restProps
}: {
  children: any;
  className: any;
  minWidth: any;
  maxWidth: any;
  justifyContent: any;
} & Record<string, any>) => (
  <div
    className={cn(styles.cell, className)}
    style={{ minWidth, maxWidth, justifyContent }}
    {...restProps}
  >
    <Typography
      className={styles.text}
      variant="body3"
      mode="compact"
      component="div"
    >
      {children}
    </Typography>
  </div>
);

export default React.memo(Cell) as any;
